// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1QXig","dragIcon":"Choice_dragIcon__1J-oL","left":"Choice_left__WD01T","input":"Choice_input___c6Pj"};